import React from "react";

function NormalTextArea({
  placeholder,
  onchange,
  value,
  name,
  label,
  type = "text",
  full = false,
  emptyField = [],
  required = false,
}) {
  return (
    <div className="form-group mb-3">
      <label className="form-label" htmlFor="exampleFormControlInput1">
        {label} {required ? <span className="text-danger">*</span> : ""}
      </label>
      <textarea
        className={`form-control ${
          emptyField.includes(name) ? "is-invalid" : ""
        }`}
        style={{ width: "100%" }}
        placeholder={`Enter ${label}`}
        onChange={onchange}
        name={name}
        value={value}
      />
    </div>
  );
}

export default NormalTextArea;
